import amazonAds from './amazonAds.js';
import googleTags from './google.js';
import metaPixel from './metaPixel.js';
import tddPixel from './tdd.js';
import { parseEventAndPayload } from './utils.js';

const randomKey = 'd24buQs3x5ag';
let debug = false;
const log = (...args) => debug &&
    // eslint-disable-next-line no-console
    console.info(...['[externalTracking]'].concat(args));
// Registry of tracking providers
const trackingProviders = {
    Meta: {
        enableDebug: () => metaPixel.enableDebug(),
        track: ({ brandId, pixels, eventName, eventType, eventPayload }) => metaPixel.track({ brandId, pixels, eventName, eventType, eventPayload })
    },
    GoogleAds: {
        enableDebug: () => googleTags.enableDebug(),
        track: ({ brandId, pixels, eventName, eventType, eventPayload }) => googleTags.track({ brandId, pixels, eventName, eventType, eventPayload })
    },
    TTD: {
        enableDebug: () => tddPixel.enableDebug(),
        track: ({ brandId, pixels, eventName, eventType, eventPayload }) => tddPixel.track({ brandId, pixels, eventName, eventType, eventPayload })
    },
    AmazonAds: {
        enableDebug: () => amazonAds.enableDebug(),
        track: ({ brandId, pixels, eventName, eventType, eventPayload }) => amazonAds.track({ brandId, pixels, eventName, eventType, eventPayload })
    }
};
/**
 * Register a new tracking provider
 */
function registerTrackingProvider(providerId, provider) {
    trackingProviders[providerId] = provider;
    log(`Registered tracking provider: ${providerId}`);
}
/**
 * Enable debug mode for all providers
 */
function enableDebug() {
    debug = true;
    log('Enabling debug mode');
    Object.values(trackingProviders).forEach(provider => provider.enableDebug());
}
function setIdentity(identity) {
    metaPixel.setIdentity(identity);
}
/**
 * Track an event with all registered providers
 */
function track(event, params, pixelContainer) {
    var _a, _b, _c;
    // Handle debug flag
    if (params === null || params === void 0 ? void 0 : params[randomKey]) {
        enableDebug();
        params[randomKey] = undefined;
    }
    log('track', { event, params, pixelContainer });
    if (!(pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.brandId) && !((_a = pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.pixels) === null || _a === void 0 ? void 0 : _a.length)) {
        // check checkoutitems array and if it has length 1 then copy over all the params from the first item
        if (((_b = params === null || params === void 0 ? void 0 : params.checkoutItems) === null || _b === void 0 ? void 0 : _b.length) === 1) {
            const firstItem = params.checkoutItems[0];
            params = Object.assign(Object.assign({}, params), { brandId: firstItem.brandId, brandName: firstItem.brandName, categoryId: firstItem.categoryId, categoryName: firstItem.categoryName, subCategoryId: firstItem.subCategoryId, subCategoryName: firstItem.subCategoryName, retailerId: firstItem.retailerId, retailerSku: firstItem.retailerSku, stacklineSku: firstItem.stacklineSku });
            if (firstItem.pixels) {
                pixelContainer = {
                    brandId: firstItem.brandId,
                    pixels: firstItem.pixels,
                };
            }
        }
    }
    // Validate required parameters
    if (!(params === null || params === void 0 ? void 0 : params.v_id) || !(pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.brandId) || !((_c = pixelContainer === null || pixelContainer === void 0 ? void 0 : pixelContainer.pixels) === null || _c === void 0 ? void 0 : _c.length)) {
        log('track required missing params', { event: event, params: params, pixelContainer: pixelContainer });
        return;
    }
    // Group pixels by provider for efficient processing
    const pixelsByProvider = pixelContainer.pixels.reduce((acc, pixel) => {
        const provider = pixel.pixelProvider;
        acc[provider] = [...(acc[provider] || []), pixel];
        return acc;
    }, {});
    // Process each provider
    Object.entries(pixelsByProvider).forEach(([provider, providerPixels]) => {
        const trackingProvider = trackingProviders[provider];
        if (!trackingProvider) {
            log(`No provider registered for ${provider}`);
            return;
        }
        try {
            providerPixels.forEach(pixel => {
                const { eventName, eventType, eventPayload } = parseEventAndPayload(event, params, pixel.eventMapping);
                if (!eventName || !((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.brandId) || (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.stacklineSku) || ((eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.checkoutItems) && eventPayload.checkoutItems.length > 0))) {
                    log('track event not supported', event, params, pixelContainer);
                    return;
                }
                trackingProvider.track({
                    brandId: pixelContainer.brandId,
                    pixels: [pixel],
                    eventName,
                    eventType: eventType,
                    eventPayload
                });
            });
        }
        catch (error) {
            log(`Error tracking with provider ${provider}:`, error);
        }
    });
}

export { enableDebug, registerTrackingProvider, setIdentity, track };
//# sourceMappingURL=externalTracking.js.map
